import axios from "../axios";
// const handleLoginApi = (email, password) => {
//     // console.log("hello from HandleLoginApi");
//     return axios.post('/api/login', { email, password }); // nhu nay nghia "email: email input", "password: password input" de khop voi Category.email ben Nodejs
// }
const getAllCategories = (inputid) => {
    // su dung cu phap cua template string
    // alert('ok');
    // console.log("hello from get all Category Service:", inputid);
    return axios.get(`/api/get-all-categories?id=${inputid}`);
    // return axios.get('/api/get-all-Category', {
    //     data: {
    //         id: inputid
    //     }
    // });

}
const createNewCategoryService = (data) => {
    // console.log("hello from createNewCategory Service:", DataTransfer);
    return axios.post('/api/create-new-category', data)
}
const deleteCategoryService = (data) => {
    // console.log("hello from createNewCategory Service:", DataTransfer);
    // return axios.delete('/api/delete-Category', data)
    return axios.delete('/api/delete-category', {
        data: {
            id: data.id
        }
    });
}
const editCategoryService = (data) => {
    console.log("hello from editCategoryService Service:", data.id);
    return axios.put('/api/edit-category', data);

}
export {
    getAllCategories,
    createNewCategoryService,
    deleteCategoryService,
    editCategoryService
}